import { FC } from "react";
import ModuleSkeleton from "shared/components/ModuleSkeleton";
import { SkeletonCard } from "./styled";

const GridCarouselSkeleton: FC = () => {
  return (
    <ModuleSkeleton>
      {[...Array(5)].map((_, index) => (
        <SkeletonCard key={`grid-carousel-skeleton-card-${index}`} />
      ))}
    </ModuleSkeleton>
  );
};

export default GridCarouselSkeleton;
